import isNil from 'lodash/isNil'

import { INITIAL_STATE } from 'modules/chat/context'

export default class ChatHelper {
  static setShowChatStorage = (value: boolean) => {
    localStorage.setItem('chat', `${value}`)
  }

  static getShowChatStorage = () => {
    const value = localStorage.getItem('chat')

    return isNil(value) ? INITIAL_STATE.showChat : value === 'true'
  }
}
